import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["title", "viewAllLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Heading, Text, Link, Box } from '@miro-site/core';
import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CategoryLink = styled(Text).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    as: 'div',
    $variant: 'p1',
    $isDashed: false,
    $ml: [null, 'auto', 'auto', 'auto'],
    $nowrap: true,
    $styles: {
      fontWeight: 400,
      transition: "color ".concat(theme.animation.transitionDuration),
      color: theme.templates.colors.secondary40
    }
  };
}).withConfig({
  displayName: "CategoryHeader__CategoryLink",
  componentId: "sc-4ljamz-0"
})(["[dir='rtl'] &:after{content:' \\2190';}[dir='ltr'] &:after{content:' \\2192';}"]);
var CategoryHeaderLink = styled(Link).withConfig({
  displayName: "CategoryHeader__CategoryHeaderLink",
  componentId: "sc-4ljamz-1"
})(["display:block;width:100%;", "{transition:color ", ";}&:hover{", ",", "{color:", ";}}&:focus{", "}.focus-trap{width:100%;}"], Heading, function (_ref2) {
  var theme = _ref2.theme;
  return theme.animation.transitionDuration;
}, Heading, CategoryLink, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primaryBlueHover;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.normalizeStyles(_objectSpread({}, theme.focus.outlines.withOffset));
});
var LinkWrapper = styled(Box).withConfig({
  displayName: "CategoryHeader__LinkWrapper",
  componentId: "sc-4ljamz-2"
})(["display:flex;flex-flow:row wrap;justify-content:space-between;align-items:center;width:100%;"]);
var CategoryHeader = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var title = _ref5.title,
      viewAllLabel = _ref5.viewAllLabel,
      props = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_jsx(CategoryHeaderLink, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(LinkWrapper, {
      children: [/*#__PURE__*/_jsx(Heading, {
        as: "h2",
        $variant: ['h3', 'h2', 'h2', 'h2'],
        $mb: [8, null, null, null],
        $align: "left",
        $styles: {
          maxWidth: [null, 645, 645, 645]
        },
        children: title
      }), /*#__PURE__*/_jsx(CategoryLink, {
        children: viewAllLabel
      })]
    })
  }));
});
CategoryHeader.displayName = 'CategoryHeader';
export default CategoryHeader;